import { render } from "./UpdatePointExchangeMagnification.vue?vue&type=template&id=4cd7f5c8&scoped=true&ts=true"
import script from "./UpdatePointExchangeMagnification.vue?vue&type=script&lang=ts"
export * from "./UpdatePointExchangeMagnification.vue?vue&type=script&lang=ts"

import "./UpdatePointExchangeMagnification.vue?vue&type=style&index=0&id=4cd7f5c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd7f5c8"]])

export default __exports__